export default __webpack_public_path__ + "static/media/holystorm.81f0a71e.png";